module.exports = __webpack_public_path__ + "img/wo.7b6a0ed.svg";